const TablePaginationPlugin = {
  install(Vue) {
    function toBoolean(value) {
      switch (true) {
        case value === true || value === 'true': return true
        case value === false || value === 'false': return false
        default: return false
      }
    }

    Object.defineProperties(Vue.prototype, {
      $pagination: {
        get() {
          const self = this
          const storedKeys = [
            'itemsPerPage',
            'page',
            'sortBy',
            'sortDesc',
            'search',
            'showDisabled'
          ]

          return {
            update(options, scope) {
              const query = { ...self.$route.query }
              storedKeys.forEach((key) => {
                delete query[key]
                const value = options[key]
                if (value) query[key] = value
              })
              self.$router.push({ query }).catch((error) => {
                if (error.name === 'NavigationDuplicated') return
                throw error
              })
              localStorage.setItem(`${scope}:qs`, JSON.stringify(options))
            },
            getOptions(scope) {
              const options = JSON.parse(localStorage.getItem(`${scope}:qs`) || '{}')
              storedKeys.forEach((key) => {
                const value = self.$route.query[key]
                if (value) options[key] = value
              })
              const { itemsPerPage, page, sortBy, sortDesc, search, showDisabled } = options

              return {
                page: parseInt(page, 10) || 1,
                sortBy: Array.isArray(sortBy) ? sortBy : [sortBy || 'updated_at'],
                sortDesc: Array.isArray(sortDesc) ? sortDesc.map(toBoolean) : [sortDesc || true].map(toBoolean),
                itemsPerPage: parseInt(itemsPerPage, 10) || 25,
                search,
                showDisabled: Boolean(showDisabled)
              }
            },
            focus() {
              const { focus } = self.$route.query
              if (!focus) return

              setTimeout(() => {
                let el = document.getElementById(`focus_${focus}`)
                if (!el) {
                  const query = { ...self.$route.query }
                  delete query.focus
                  self.$router.push({ query })
                  return
                }

                el.scrollIntoView()
                window.scrollTo(0, window.scrollY - 200)
                while (el) {
                  if (el.tagName.toLowerCase() === 'tr') {
                    el.style.background = '#eeeeee'
                    break
                  }
                  el = el.parentElement
                }
              }, 100)
            }
          }
        }
      }
    })
  }
}

export default TablePaginationPlugin
